import Vue from "vue";
import "vant/lib/index.css";
import {
  Button,
  Cell,
  CellGroup,
  Dialog,
  Icon,
  Switch,
  Stepper,
  Popup,
  List,
  Row,
  Col,
  Swipe,
  SwipeItem,
  Form,
  Field,
  Radio,
  RadioGroup,
  Checkbox,
  Popover,
  Picker,
  Uploader,
  DropdownMenu,
  DropdownItem
} from "vant";

[
  Swipe,
  SwipeItem,
  Button,
  Cell,
  CellGroup,
  Dialog,
  Icon,
  Switch,
  Stepper,
  Popup,
  List,
  Row,
  Col,
  Form,
  Field,
  Radio,
  RadioGroup,
  Checkbox,
  Popover,
  Picker,
  Uploader,
  DropdownMenu,
  DropdownItem
].forEach(c => Vue.use(c));

Vue.prototype.$confirm = Dialog.confirm;
